import React from 'react';

/**
 * PROTEGO Brand Symbol
 * Abstract representation of justice and protection
 * - Central vertical axis (law, stability)
 * - Symmetrical balanced elements (justice)
 * - Shield-like architectural form (protection)
 * - Modern, minimal, institutional design
 */
const ProtegoSymbol = ({ 
  size = 120, 
  color = '#C9A961',
  strokeWidth = 1.5,
  className = '' 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 120 120" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="PROTEGO symbol"
    >
      {/* Central vertical axis - pillar of law */}
      <line 
        x1="60" y1="15" 
        x2="60" y2="105" 
        stroke={color} 
        strokeWidth={strokeWidth}
      />
      
      {/* Top architectural element - crown/authority */}
      <path 
        d="M40 25 L60 15 L80 25" 
        stroke={color} 
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Upper balance arms */}
      <line 
        x1="30" y1="40" 
        x2="90" y2="40" 
        stroke={color} 
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      
      {/* Left balance element */}
      <path 
        d="M30 40 L25 50 L35 50 Z" 
        stroke={color} 
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinejoin="round"
      />
      
      {/* Right balance element */}
      <path 
        d="M90 40 L85 50 L95 50 Z" 
        stroke={color} 
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinejoin="round"
      />
      
      {/* Shield outline - protection */}
      <path 
        d="M25 55 L25 75 Q25 95 60 105 Q95 95 95 75 L95 55" 
        stroke={color} 
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Inner shield detail - architectural stability */}
      <path 
        d="M40 60 L40 72 Q40 85 60 92 Q80 85 80 72 L80 60" 
        stroke={color} 
        strokeWidth={strokeWidth * 0.8}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.7"
      />
      
      {/* Horizontal stabilizers */}
      <line 
        x1="35" y1="55" 
        x2="85" y2="55" 
        stroke={color} 
        strokeWidth={strokeWidth * 0.8}
        strokeLinecap="round"
        opacity="0.5"
      />
    </svg>
  );
};

export default ProtegoSymbol;
